import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Moon, Sun, Home, ArrowLeft } from "lucide-react";

const navBtn =
  "flex h-9 items-center gap-1.5 rounded-md border border-border px-3 text-xs font-bold uppercase tracking-wider text-foreground transition-colors hover:bg-secondary";

export const Header = ({ onHome, onBack, showNav = true }) => {
  const [dark, setDark] = useState(() => localStorage.getItem("fdm_theme") === "dark");
  const location = useLocation();
  const navigate = useNavigate();

  const goHome = () => (onHome ? onHome() : navigate("/"));
  const goBack = () => {
    if (onBack) return onBack();
    if (window.history.length > 1) navigate(-1);
    else navigate("/");
  };

  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("fdm_theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/85 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5 sm:px-8">
        <Link to="/" className="flex items-center gap-2.5" data-testid="header-logo-link">
          <img
            src="/logo.png"
            alt="Fast Duck Motors"
            data-testid="header-logo-image"
            className="h-11 w-11 object-contain dark:invert"
          />
          <span className="font-display text-lg font-black leading-none tracking-tight">
            FAST DUCK
            <span className="block text-[10px] font-bold uppercase tracking-[0.3em] text-muted-foreground">
              Motors
            </span>
          </span>
        </Link>

        <div className="flex items-center gap-2">
          {showNav && (
            <>
              <button type="button" onClick={goHome} data-testid="header-home-button" className={navBtn} aria-label="Back to start">
                <Home size={15} /> <span className="hidden sm:inline">Start</span>
              </button>
              <button type="button" onClick={goBack} data-testid="header-back-button" className={navBtn} aria-label="Previous page">
                <ArrowLeft size={15} /> <span className="hidden sm:inline">Back</span>
              </button>
            </>
          )}
          <Link
            to={location.pathname === "/admin" ? "/" : "/admin"}
            data-testid="header-admin-link"
            className="rounded-md px-3 py-2 text-xs font-bold uppercase tracking-wider text-muted-foreground transition-colors hover:text-foreground"
          >
            {location.pathname === "/admin" ? "Builder" : "Admin"}
          </Link>
          <button
            data-testid="theme-toggle-button"
            onClick={() => setDark((d) => !d)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-border text-foreground transition-colors hover:bg-secondary"
            aria-label="Toggle theme"
          >
            {dark ? <Sun size={17} /> : <Moon size={17} />}
          </button>
        </div>
      </div>
    </header>
  );
};
